import React from 'react';

const RawHTML = ({ children }: { children: string }) => <div dangerouslySetInnerHTML={{ __html: children }} />;

export default RawHTML;
